export default "__VITE_ASSET__DzUG9TPj__"